import axios from 'axios';
import scheduleFilter from '../../services/scheduleFilter';
import { getSchedule, getScheduleAndVods } from '../../apis/schedule';
import {
  FETCH_SCHEDULE_LOADING,
  FETCH_SCHEDULE_SUCCESS,
  FETCH_SCHEDULE_FAILED,
  FILTER_SCHEDULE_LOADING,
  FILTER_SCHEDULE_FAILED,
  FILTER_SCHEDULE_SUCCESS,
  ACTIVATE_SCHEDULE_FILTER,
  FETCH_VODS_LOADING,
  FETCH_VODS_FAILED,
  FETCH_VODS_SUCCESS,
} from './types';

export const fetchSchedule = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_SCHEDULE_LOADING });
  try {
    const { slug } = getState().city;
    const schedule = await getSchedule(slug);

    dispatch({ type: FETCH_SCHEDULE_SUCCESS, payload: schedule });
  } catch (error) {
    console.log(error);
    dispatch({ type: FETCH_SCHEDULE_FAILED, payload: error.message });
  }
};

export const fetchScheduleAndVods = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_SCHEDULE_LOADING });
  try {
    const { slug } = getState().city;
    const [schedule, vods] = await getScheduleAndVods(slug, 'homepage');

    dispatch({ type: FETCH_SCHEDULE_SUCCESS, payload: schedule });
    dispatch({ type: FETCH_VODS_SUCCESS, payload: vods });
  } catch (error) {
    console.log(error);
    dispatch({ type: FETCH_SCHEDULE_FAILED, payload: error.message });
  }
};

export const filterSchedule = (filter) => async (dispatch, getState) => {
  dispatch({ type: FILTER_SCHEDULE_LOADING });
  try {
    const { films } = getState().schedule;
    const filteredFilms = await scheduleFilter(films, filter);
    
    dispatch({
      type: FILTER_SCHEDULE_SUCCESS,
      payload: { filteredFilms },
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: FILTER_SCHEDULE_FAILED });
  }
};

export const filterScheduleAndVods = (filter) => async (dispatch, getState) => {
  dispatch({ type: FILTER_SCHEDULE_LOADING });
  try {
    const { films } = getState().schedule;
    const { vods } = getState();
    const filteredFilms = await scheduleFilter([...films, ...vods], filter);

    dispatch({
      type: FILTER_SCHEDULE_SUCCESS,
      payload: { filteredFilms },
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: FILTER_SCHEDULE_FAILED });
  }
};

export const activateScheduleFilter = (filter) => (dispatch) => {
  dispatch({ type: ACTIVATE_SCHEDULE_FILTER, payload: filter });
};

export const fetchVods = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_VODS_LOADING });
  try {
    const { data } = await axios.get('/schedule/vods/');
    dispatch({ type: FETCH_VODS_SUCCESS, payload: data });
  } catch (error) {
    console.log(error);
    dispatch({ type: FETCH_VODS_FAILED, payload: error.message });
  }
};
